import SPortfolioDetails from "./SPortfolioDetails_web"
export default SPortfolioDetails
